import { buildLink, KitchenSinkRoute, RouteSlotInput } from '@luks/ui';

import { useListingNewsroomTreatmentQuery } from '../../../generated/queries';
import { isDefined } from '../../commons/is-defined';
import { buildDrupalImage } from '../Image';

export const mapParagraphNewsroomTreatment = (
  input: ParagraphNewsroomTreatmentFragment,
): RouteSlotInput<typeof KitchenSinkRoute, 'body', 'GridTeaser'> => ({
  key: 'GridTeaser',
  input: function useNewsroomTreatment() {
    const { data, isLoading, isFetching } = useListingNewsroomTreatmentQuery({
      argument: input.argument,
      offset: 0,
      limit: 4,
    });
    return [
      {
        title: 'News',
        teasers:
          data?.listingNewsroomTreatment.items.filter(isDefined).map((it) => ({
            title: it.title,
            Link: buildLink({ href: it.path }),
            date: it.date,
            Image: buildDrupalImage(it.teaserImage, 'teaser'),
          })) || [],
        Link: buildLink({ href: '/newsroom' }),
        linkText: 'Alle News',
        id: 'News',
      },
      isLoading || isFetching
        ? 102
        : (data?.listingNewsroomTreatment.items.length || 0) > 0
        ? 200
        : 404,
    ];
  },
});
